export const getHoursPending = () => {
    return {
        type: 'GET_HOURS_PENDING'
    }
};

export const getWarmHoursSuccess = (warmHours) => {
    return {
        type: 'GET_WARM_HOURS_SUCCESS',
        warmHours,

    }
};

export const selectHour = (hour) => {
    return {
        type: 'SELECT_HOUR',
        selected: { hour }
    };
};

export const getHoursError = error => {
    return {
        type: 'GET_HOURS_ERROR',
        error: error
    }
};

export const getWarmHours = () => {
    return dispatch => {
        dispatch(getHoursPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/getWarmConfigList`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getHoursError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getWarmHoursSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


export const addWarmHour = obj => {
    return dispatch => {
        dispatch(getHoursPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/addNewWarmConfig`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getWarmHours());
                } else {
                    dispatch(getHoursError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const updateWarmHour = obj => {
    return dispatch => {
        dispatch(getHoursPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/updateWarmConfig`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getWarmHours());
                } else {
                    dispatch(getHoursError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteWarmHour = (configId) => {
    return dispatch => {
        dispatch(getHoursPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/deleteWarmConfig?configId=${configId}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getWarmHours());
                } else {
                    dispatch(getHoursError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
